import React, { useState } from "react";
import { useRouter, withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { EmailVerificationContainer, FieldsContainer, ResendCode } from "./EmailVerification.styles";
import { Button, TitleSubtitle } from "../..";
import { VerificationCodeInput } from "../../VerificationCodeInput/VerificationCodeInput";
import { Button as MuiButton } from "@mui/material";
import { CTAForthContainer } from "../../../pages/Register/Register.styles";

interface EmailVerificationProps extends WithRouterProps {
    onNextButtonClick: Function;
}

const EmailVerification: React.FC<EmailVerificationProps> = ({
    onNextButtonClick
}) => {
    const router = useRouter();
    const inputLength = 6;
    const [verificationCode, setVerificationCode] = useState<string>('');
    const [verificationCodeHasError, setVerificationCodeHasError] = useState<boolean>(false);

    const isContinueButtonDisabled = () => {
        return verificationCode.length < inputLength || verificationCodeHasError
    }

    return (
        <EmailVerificationContainer>
            <TitleSubtitle
                size="sm"
                title="Verify Your Email"
                subTitle="We just emailed you a code, enter it below to verify your email address" />
            <FieldsContainer>
                <VerificationCodeInput inputLength={6}
                    getConcatenatedValues={(value: string) => { setVerificationCode(value) }}
                    hasError={(value: boolean) => { setVerificationCodeHasError(value) }} />
            </FieldsContainer>
            <ResendCode>Didn’t get it? Check spam folder or <MuiButton variant="text" style={{textTransform: 'none'}}>Resend code</MuiButton></ResendCode>
            <CTAForthContainer>
                <Button 
                onClick={() => onNextButtonClick()}
                disabled={isContinueButtonDisabled()}
                > Continue </Button>
            </CTAForthContainer>
        </EmailVerificationContainer>
    );
};

EmailVerification.displayName = "EmailVerification";

const ComponentWithRouter = withRouter(EmailVerification)

export { ComponentWithRouter as EmailVerification };
